import dayjs from 'dayjs';
import { Calendar as CalendarIcon } from 'lucide-react';
import DatePicker from '../../../../../../../../../components/Common/UI/DataPicker';
import { cn } from '../../../../../../../../../utils/styles';
import { IBatchDownloadState } from '../../../../../../../../../Guidance/components/Pages/BatchDownload/Search';

interface IDateFilterProps {
  from: string;
  to: string;
  handleDispatch: (payload: Partial<IBatchDownloadState>) => void;
}

function DateFilter({ from, to, handleDispatch }: IDateFilterProps) {
  return (
    <div className="flex lg:gap-[70px] gap-[20px] items-end flex-wrap">
      <div className="lg:mb-[15px] lg:w-auto w-full">Data Range</div>
      <div className="flex items-center lg:gap-[70px] gap-[20px] flex-wrap xs:w-auto w-full">
        <div className="sm:w-[250px] xs:w-[300px] w-full">
          <div className="text-addition1 uppercase text-[12px] mb-[13px]">From Date</div>
          <DatePicker
            date={dayjs(from).toDate()}
            className="font-normal border-addition1-10 bg-white w-full justify-between"
            icon={
              <CalendarIcon
                className={cn(
                  'ml-[15px] h-[18px] w-[18px] opacity-70 [&_rect]:stroke-addition5 [&_path]:stroke-addition5',
                )}
              />
            }
            onSelect={(date?: Date) => {
              handleDispatch({ from: date?.toString() });
            }}
          />
        </div>
        <div className="sm:w-[250px] xs:w-[300px] w-full">
          <div className="text-addition1 uppercase text-[12px] mb-[13px]">To Date</div>
          <DatePicker
            icon={
              <CalendarIcon
                className={cn(
                  'ml-[15px] h-[18px] w-[18px] opacity-70 [&_rect]:stroke-addition5 [&_path]:stroke-addition5',
                )}
              />
            }
            className="font-normal border-addition1-10 bg-white w-full justify-between"
            date={dayjs(to).toDate()}
            onSelect={(date?: Date) => {
              handleDispatch({ to: date?.toString() });
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default DateFilter;
